import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IYaslandirmaRapor_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYaslandirmaRapor_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetAktifSirket: any[];
  GetAktifSirket_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  CariEkstreToplam: any[];
  CariEkstreToplam_dummy: any[];
  GetYaslandirmaRaporu: any[];
  GetYaslandirmaRaporu_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  isComp833287Visible: "visible" | "hidden";
  isComp475693Visible: "visible" | "hidden";
  isComp660102Visible: "visible" | "hidden";
  isComp46342Visible: "visible" | "hidden";
  isComp978445Visible: "visible" | "hidden";
  isComp309408Visible: "visible" | "hidden";
  isComp950754Visible: "visible" | "hidden";
}

export class YaslandirmaRapor_ScreenBase extends React.PureComponent<
  IYaslandirmaRapor_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  yaslandirmarapor_168896_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 249563,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORDS FOUNDED",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 347531,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 120533,
          PropertyName: "value",
          Value: "DEPT TOTAL",
          TagName: "Label5_value",
        },
        {
          Id: 275111,
          PropertyName: "value",
          Value: "TOTAL RECEIVABLES",
          TagName: "Label5_0_value",
        },
        {
          Id: 389349,
          PropertyName: "value",
          Value: "BALANCE",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "DOCUMENT NO",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "PAYMENT DUE",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 747495,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "CLOSED AMOUNT",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 851668,
          PropertyName: "title",
          Value: "ACTION TYPE",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "EXPLANATION",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "CURRENCY TYPE",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 236994,
          PropertyName: "value",
          Value: "Aging Report",
          TagName: "Label25_value",
        },
        {
          Id: 75829,
          PropertyName: "value",
          Value: "DUE DEBTS ARE LISTED BASED ON REMAINING DAYS.",
          TagName: "Label26_value",
        },
        {
          Id: 962927,
          PropertyName: "value",
          Value: "TOTAL MATURITY DAY",
          TagName: "Label15_value",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "EXPORT TO EXCEL",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 249563,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para agregar",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 347531,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 120533,
          PropertyName: "value",
          Value: "Total de deuda",
          TagName: "Label5_value",
        },
        {
          Id: 275111,
          PropertyName: "value",
          Value: "Total de cuentas por cobrar",
          TagName: "Label5_0_value",
        },
        {
          Id: 389349,
          PropertyName: "value",
          Value: "Saldo",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "Número de documento",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "Fecha de vencimiento",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 747495,
          PropertyName: "title",
          Value: "Valor",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "Valor final",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 851668,
          PropertyName: "title",
          Value: "Tipo de transacción",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "Descripción",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "Tipo de moneda",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 236994,
          PropertyName: "value",
          Value: "Informe de antigüedad",
          TagName: "Label25_value",
        },
        {
          Id: 75829,
          PropertyName: "value",
          Value: "Sus deudas vencidas se listan según los días restantes.",
          TagName: "Label26_value",
        },
        {
          Id: 962927,
          PropertyName: "value",
          Value: "Fecha de vencimiento promedio",
          TagName: "Label15_value",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "Exportar a Excel",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 249563,
          PropertyName: "placeholder",
          Value: "Vaden No, OEM No , nom du produit, marque, modèle, véhicule",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun résultat",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 347531,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 120533,
          PropertyName: "value",
          Value: "Total dettes",
          TagName: "Label5_value",
        },
        {
          Id: 275111,
          PropertyName: "value",
          Value: "Total créances",
          TagName: "Label5_0_value",
        },
        {
          Id: 389349,
          PropertyName: "value",
          Value: "Solde",
          TagName: "Label9_0_value",
        },
        {
          Id: 94372,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 700907,
          PropertyName: "title",
          Value: "N° Document",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 349619,
          PropertyName: "title",
          Value: "Date d’échéance",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 747495,
          PropertyName: "title",
          Value: "Montant",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 620702,
          PropertyName: "title",
          Value: "Montant réglé",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 851668,
          PropertyName: "title",
          Value: "Type de transaction",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 128921,
          PropertyName: "title",
          Value: "Description",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 210402,
          PropertyName: "title",
          Value: "Devise",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 236994,
          PropertyName: "value",
          Value: "Rapport d’ancienneté",
          TagName: "Label25_value",
        },
        {
          Id: 75829,
          PropertyName: "value",
          Value: "Vos dettes échues sont listées par jour restant",
          TagName: "Label26_value",
        },
        {
          Id: 962927,
          PropertyName: "value",
          Value: "Durée moyenne d’échéance",
          TagName: "Label15_value",
        },
        {
          Id: 612540,
          PropertyName: "label",
          Value: "Exporter vers Excel",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "1fc65453-e34f-4384-bb0e-b39516f04c5a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 249563,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 982775, PropertyName: "label", Value: "Turkish" },
        { Id: 57681, PropertyName: "label", Value: "English" },
        { Id: 189836, PropertyName: "label", Value: "Spanish" },
        { Id: 75571, PropertyName: "label", Value: "French" },
        { Id: 347531, PropertyName: "label", Value: "Profil" },
        { Id: 120533, PropertyName: "value", Value: "Borç Toplamı" },
        { Id: 660102, PropertyName: "value", Value: "₺" },
        { Id: 275111, PropertyName: "value", Value: "Alacak Toplamı" },
        { Id: 978445, PropertyName: "value", Value: "₺" },
        { Id: 389349, PropertyName: "value", Value: "Bakiye" },
        { Id: 950754, PropertyName: "value", Value: "₺" },
        { Id: 236994, PropertyName: "value", Value: "Yaşlandırma Raporu" },
        {
          Id: 75829,
          PropertyName: "value",
          Value: "Vadesi Gelmiş Borçlarınız Kalan Gün Bazlı Listelenmektedir.",
        },
        { Id: 612540, PropertyName: "label", Value: "Excele Aktar" },
        {
          Id: 168896,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 94372, PropertyName: "title", Value: "Tarih" },
        { Id: 68100, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 700907, PropertyName: "title", Value: "Belge No" },
        { Id: 166336, PropertyName: "value", Value: "[datafield:belge_no]" },
        { Id: 349619, PropertyName: "title", Value: "Vade Tarihi" },
        { Id: 337302, PropertyName: "value", Value: "[datafield:vade_tarihi]" },
        { Id: 747495, PropertyName: "title", Value: "Tutar" },
        { Id: 501236, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 620702, PropertyName: "title", Value: "Kapatılan Tutar" },
        {
          Id: 705558,
          PropertyName: "value",
          Value: "[datafield:kapatilan_tutar]",
        },
        { Id: 851668, PropertyName: "title", Value: "Hareket Türü" },
        { Id: 20557, PropertyName: "value", Value: "[datafield:hareket_turu]" },
        { Id: 128921, PropertyName: "title", Value: "Açıklama" },
        { Id: 335678, PropertyName: "value", Value: "[datafield:aciklama]" },
        { Id: 210402, PropertyName: "title", Value: "Doviz Türü" },
        { Id: 843128, PropertyName: "value", Value: "[datafield:doviz_turu]" },
        { Id: 962927, PropertyName: "value", Value: "Ortalama Vade Günü" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.yaslandirmarapor_249563_value_kuikaTextInputRef = React.createRef();
    this.yaslandirmarapor_168896_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GetAktifSirket: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetCariParaBirimi: [],
      CariEkstreToplam: [],
      GetYaslandirmaRaporu: [],
      ExportExcel: "",
      isComp833287Visible: "hidden",
      isComp475693Visible: "hidden",
      isComp660102Visible: "hidden",
      isComp46342Visible: "hidden",
      isComp978445Visible: "hidden",
      isComp309408Visible: "hidden",
      isComp950754Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yaslandirmarapor",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.YaslandirmaRaporPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.YaslandirmaRaporPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "yaslandirmarapor",
      "blank_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "yaslandirmarapor",
      "blank_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YaslandirmaRaporPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.YaslandirmaRaporPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YaslandirmaRaporPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YaslandirmaRapor/YaslandirmaRaporPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp833287Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetAktifSirket = result?.data.getAktifSirket;
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.yaslandirmarapor_707697_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YaslandirmaRaporPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YaslandirmaRaporPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YaslandirmaRaporPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YaslandirmaRaporPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      paraBirimi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      isYurtici_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "number"
      ),
      CariKod_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      Bakiye_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CariEkstreToplam !== undefined
            ? stateVars.CariEkstreToplam?.length > 0
              ? stateVars.CariEkstreToplam[0].bakiye
              : null
            : this.state.CariEkstreToplam?.length > 0
            ? this.state.CariEkstreToplam[0].bakiye
            : null
        ),
        "number"
      ),
      CariKod_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      DovizTipi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YaslandirmaRapor/YaslandirmaRaporPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.isComp475693Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp660102Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp46342Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp978445Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp309408Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp950754Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.yaslandirmarapor_150714_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.yaslandirmarapor_756714_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.yaslandirmarapor_475693_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.yaslandirmarapor_46342_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.yaslandirmarapor_309408_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.CariEkstreToplam = result?.data.cariEkstreToplam;
    formVars.yaslandirmarapor_513622_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].borc
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].borc
        : null
    );
    formVars.yaslandirmarapor_343594_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].alacak
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].alacak
        : null
    );
    formVars.yaslandirmarapor_849945_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );
    stateVars.GetYaslandirmaRaporu = result?.data.getYaslandirmaRaporu;

    formVars.yaslandirmarapor_98156_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetYaslandirmaRaporu !== undefined
        ? stateVars.GetYaslandirmaRaporu?.length > 0
          ? stateVars.GetYaslandirmaRaporu[0].ortalamaVadeGunu
          : null
        : this.state.GetYaslandirmaRaporu?.length > 0
        ? this.state.GetYaslandirmaRaporu[0].ortalamaVadeGunu
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YaslandirmaRaporPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YaslandirmaRaporPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yaslandirmarapor_150714_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp833287Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yaslandirmarapor_756714_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.yaslandirmarapor_707697_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.yaslandirmarapor_616332_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.yaslandirmarapor_475693_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp475693Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp660102Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yaslandirmarapor_513622_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].borc
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].borc
        : null
    );

    formVars.yaslandirmarapor_46342_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp46342Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp978445Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yaslandirmarapor_343594_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].alacak
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].alacak
        : null
    );

    formVars.yaslandirmarapor_309408_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp309408Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp950754Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yaslandirmarapor_849945_value = ReactSystemFunctions.toString(
      this,
      stateVars.CariEkstreToplam !== undefined
        ? stateVars.CariEkstreToplam?.length > 0
          ? stateVars.CariEkstreToplam[0].bakiye
          : null
        : this.state.CariEkstreToplam?.length > 0
        ? this.state.CariEkstreToplam[0].bakiye
        : null
    );

    stateVars.dataSource_168896 =
      stateVars.GetYaslandirmaRaporu ?? this.state.GetYaslandirmaRaporu;
    formVars.yaslandirmarapor_98156_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetYaslandirmaRaporu !== undefined
        ? stateVars.GetYaslandirmaRaporu?.length > 0
          ? stateVars.GetYaslandirmaRaporu[0].ortalamaVadeGunu
          : null
        : this.state.GetYaslandirmaRaporu?.length > 0
        ? this.state.GetYaslandirmaRaporu[0].ortalamaVadeGunu
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_249563_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yaslandirmarapor_249563_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YaslandirmaRapor",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_833287_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YaslandirmaRapor",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_488796_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YaslandirmaRapor",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "493283",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_982775_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_57681_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_189836_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_75571_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_347531_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YaslandirmaRapor",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YaslandirmaRaporComponent_612540_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.GetYaslandirmaRaporu),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YaslandirmaRapor/YaslandirmaRaporComponent_612540_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 493283] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YaslandirmaRaporPageInit();
    }
  }
}
